import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ZpDataService } from './../services/zp-data.service';
import { UserInfoService } from './../services/user-info.service';
import { IUser } from './../models/user.model';
import { Subscription } from 'rxjs';
import { PlanReviewRoutesService } from '../services/plan-review-routes.service';
import { GetInfoAndPassService } from '../services/get-info-and-pass.service';
import { ThemeService } from '../theme/theme-service.service';
import { ProfessionalFeaturesService } from '../services/professional-features.service';

@Component({
    selector: 'app-section-box',
    templateUrl: './section-box.component.html',
    styleUrls: ['./section-box.component.scss'],
    standalone: false
})
export class SectionBoxComponent implements OnInit {
  @Input() public section;
  @Input() public planCategory;
  @Output() public deleteItem: EventEmitter<string> = new EventEmitter<string>();
  public showDialog = false;
  public itemToDeleteId;
  public itemNameforDialog;
  public mySection;
  public myUser: IUser;
  public subscription: Subscription;
  public sectionName: any;
  public isDeleted: boolean;
  public returnToPlanReview: boolean;
  public itemDisappeared: boolean = false;
  public planReviewItemName;
  categorySection: any;
  companyDetails: { userType?: string; professionalLicense?: string; funded?: boolean; hideSponsor?: boolean; directInvoice?: boolean; email?: string; company?: string; logo?: string; firstName?: string; lastName?: string; nfz?:boolean };
  isNFZ: any;
  dataIsLoaded: boolean = false;

  constructor(private router: Router,
    private professionalFeatures: ProfessionalFeaturesService,
    private zenplansDataService: ZpDataService,
    private userInfo: UserInfoService,
    private planReviewRoutes: PlanReviewRoutesService,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService) {
    this.subscription = this.userInfo.getMessage().subscribe(user => {
      this.myUser = JSON.parse(user);
    });
  }

  async ngOnInit() {
    let kk = 0;
    this.section.items.forEach(element => {
      this.planReviewItemName = element.sectionName;
      this.sectionName = element.sectionName;
    });
    switch (this.sectionName) {
      case "bank-account":
      this.sectionName = 'Account Balance'
        break;
      case "item-of-value":
      this.sectionName = 'Item Value'
        break;
      case "unlisted-share":
      this.sectionName = 'Share Value'
        break;
      case "listed-share":
      this.sectionName = 'Share Value'
        break;
      case "managed-portfolio":
      this.sectionName = 'Portfolio Value'
        break;
      case "money-owed-to-me":
      this.sectionName = 'Amount Owed'
        break;
      case "pension":
      this.sectionName = 'Pension Value'
        break;
      case "property":
      this.sectionName = 'Property Value'
        break;
      case "financial-product":
      this.sectionName = 'Product Value'
        break;
      case "other-asset":
      this.sectionName = 'Asset Value'
        break;
      case "mortgage":
      this.sectionName = 'Outstanding Balance'
        break;
      case "loan":
      this.sectionName = 'Outstanding Balance'
        break;
    }
    await this.loadProfessionalDataForNFZ();
  }

  async loadProfessionalDataForNFZ() {
    // Use methods from ProfessionalFeaturesService
    await this.professionalFeatures.checkProfessionalCompanyDetails(this.myUser);

    // Access companyDetails from ProfessionalFeaturesService
    this.companyDetails = this.professionalFeatures.companyDetails;
    console.log("companyDetails - ", this.companyDetails);
    if (this.companyDetails && this.companyDetails.nfz) {
      this.isNFZ = true;
    } else {
      this.isNFZ = false;
    }
    // Set dataIsLoaded to true
    this.dataIsLoaded = true;
  }

  view(Id: string) {
    this.router.navigate(['/' + this.section["viewUrl"] + "/" + Id]);
  }

  add() {
    this.returnToPlanReview = true;
    this.myUser.planCategory = this.planCategory
    this.myUser.returnToPlanReview = this.returnToPlanReview;
    this.planReviewRoutes.myMethod(this.returnToPlanReview);
    this.getInfoAndPassService.getInfoAndPass(this.planCategory)
    this.router.navigate(['/' + this.section["addurl"]]);
  }

  async callDialog(id, name) {
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }

  deleteOnScreen() {
    this.itemDisappeared = true;
  }

  async deleteByEvent(choice) {
    this.showDialog = !this.showDialog;
    if (choice === 'Yes') {
      let clientId = this.myUser.sharedPlanUserId ? this.myUser.sharedPlanUserId : this.myUser.Id;
      await this.zenplansDataService.deleteItem(this.itemToDeleteId, this.section["sectionName"], clientId);
      this.deleteItem.emit(choice);
      var Id: string;
      if (this.myUser.sharedPlanUserId) {
        Id = this.myUser.sharedPlanUserId
      }
      else {
        Id = this.myUser.Id;
      }
    }  
    else {
      this.deleteOnScreen()
    }
  }
}
